// @generated by protoc-gen-es v1.0.0 with parameter "target=js+dts,ts_nocheck=false"
// @generated from file api/core/svc_adminka.proto (package com.diagnocat.core, syntax proto3)
/* eslint-disable */

import { Empty, proto3, Timestamp } from "@bufbuild/protobuf";
import { User } from "../../model/dto_user_pb.js";
import { FeatureFlag, Organization, OrganizationContacts } from "../../model/dto_organization_pb.js";
import { OrganizationStaff } from "../../model/dto_organization_staff_pb.js";
import { LoadLevel } from "../../model/dto_system_load_pb.js";

/**
 * @generated from enum com.diagnocat.core.AdminUserListStreamSortBy
 */
export const AdminUserListStreamSortBy = proto3.makeEnum(
  "com.diagnocat.core.AdminUserListStreamSortBy",
  [
    {no: 0, name: "AdminUserListStreamSortByLastName"},
    {no: 1, name: "AdminUserListStreamSortByLastModification"},
    {no: 2, name: "AdminUserListStreamSortByEmail"},
    {no: 3, name: "AdminUserListStreamSortByFirstName"},
    {no: 4, name: "AdminUserListStreamSortByCreatedAt"},
  ],
);

/**
 * @generated from enum com.diagnocat.core.AdminOrganizationListStreamSortBy
 */
export const AdminOrganizationListStreamSortBy = proto3.makeEnum(
  "com.diagnocat.core.AdminOrganizationListStreamSortBy",
  [
    {no: 0, name: "AdminOrganizationListStreamSortByLastModification"},
    {no: 1, name: "AdminOrganizationListStreamSortByName"},
    {no: 2, name: "AdminOrganizationListStreamSortByOwnerEmail"},
    {no: 3, name: "AdminOrganizationListStreamSortByCreatedAt"},
    {no: 4, name: "AdminOrganizationListStreamSortByCountry"},
    {no: 5, name: "AdminOrganizationListStreamSortByDistributorEmail"},
    {no: 6, name: "AdminOrganizationListStreamSortBySubscriptionEndDate"},
  ],
);

/**
 * @generated from message com.diagnocat.core.AdminUserListStreamReq
 */
export const AdminUserListStreamReq = proto3.makeMessageType(
  "com.diagnocat.core.AdminUserListStreamReq",
  () => [
    { no: 2, name: "SearchString", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 31, name: "Sort", kind: "message", T: AdminUserListStreamSort, repeated: true },
    { no: 100, name: "StartFromUserID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 101, name: "Limit", kind: "scalar", T: 13 /* ScalarType.UINT32 */ },
  ],
);

/**
 * @generated from message com.diagnocat.core.AdminUserListStreamSort
 */
export const AdminUserListStreamSort = proto3.makeMessageType(
  "com.diagnocat.core.AdminUserListStreamSort",
  () => [
    { no: 1, name: "By", kind: "enum", T: proto3.getEnumType(AdminUserListStreamSortBy) },
    { no: 2, name: "Ascending", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ],
);

/**
 * @generated from message com.diagnocat.core.AdminUserListStreamResp
 */
export const AdminUserListStreamResp = proto3.makeMessageType(
  "com.diagnocat.core.AdminUserListStreamResp",
  () => [
    { no: 10, name: "InitialUsers", kind: "message", T: AdminUserListStreamResp_UsersList, oneof: "Update" },
    { no: 11, name: "UserUpdated", kind: "message", T: User, oneof: "Update" },
    { no: 101, name: "Ping", kind: "message", T: Empty, oneof: "Update" },
  ],
);

/**
 * @generated from message com.diagnocat.core.AdminUserListStreamResp.UsersList
 */
export const AdminUserListStreamResp_UsersList = proto3.makeMessageType(
  "com.diagnocat.core.AdminUserListStreamResp.UsersList",
  () => [
    { no: 1, name: "Users", kind: "message", T: User, repeated: true },
  ],
  {localName: "AdminUserListStreamResp_UsersList"},
);

/**
 * @generated from message com.diagnocat.core.AdminOrganizationListStreamReq
 */
export const AdminOrganizationListStreamReq = proto3.makeMessageType(
  "com.diagnocat.core.AdminOrganizationListStreamReq",
  () => [
    { no: 1, name: "ShowDistributors", kind: "message", T: AdminOrganizationListStreamReq_DistributorsFilter, oneof: "Filter" },
    { no: 3, name: "ShowDistributorClients", kind: "message", T: AdminOrganizationListStreamReq_DistributorClientsFilter, oneof: "Filter" },
    { no: 4, name: "ShowDSOClients", kind: "message", T: AdminOrganizationListStreamReq_DSOClientsFilter, oneof: "Filter" },
    { no: 5, name: "ShowDSOs", kind: "message", T: AdminOrganizationListStreamReq_DSOsFilter, oneof: "Filter" },
    { no: 2, name: "SearchString", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 31, name: "Sort", kind: "message", T: AdminOrganizationListStreamSort, repeated: true },
    { no: 100, name: "StartFromOrganizationID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 101, name: "Limit", kind: "scalar", T: 13 /* ScalarType.UINT32 */ },
    { no: 104, name: "SubscriptionEndDateFrom", kind: "message", T: Timestamp },
    { no: 105, name: "SubscriptionEndDateTo", kind: "message", T: Timestamp },
    { no: 106, name: "OnlyActiveSubscriptions", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 102, name: "DistributorEmail", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 103, name: "FilterByKind", kind: "enum", T: proto3.getEnumType(AdminOrganizationListStreamReq_OrganizationKind), repeated: true },
  ],
);

/**
 * @generated from enum com.diagnocat.core.AdminOrganizationListStreamReq.OrganizationKind
 */
export const AdminOrganizationListStreamReq_OrganizationKind = proto3.makeEnum(
  "com.diagnocat.core.AdminOrganizationListStreamReq.OrganizationKind",
  [
    {no: 0, name: "All"},
    {no: 1, name: "Distributors"},
    {no: 2, name: "DistributorClients"},
  ],
);

/**
 * `Filter`: [optional] narrow the listing to a specific slice of organizations.
 *          If not set - all organizations are streamed (subject to caller's permissions).
 *
 * @generated from message com.diagnocat.core.AdminOrganizationListStreamReq.DistributorsFilter
 */
export const AdminOrganizationListStreamReq_DistributorsFilter = proto3.makeMessageType(
  "com.diagnocat.core.AdminOrganizationListStreamReq.DistributorsFilter",
  () => [
    { no: 1, name: "OwnerEmail", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
  ],
  {localName: "AdminOrganizationListStreamReq_DistributorsFilter"},
);

/**
 * @generated from message com.diagnocat.core.AdminOrganizationListStreamReq.DistributorClientsFilter
 */
export const AdminOrganizationListStreamReq_DistributorClientsFilter = proto3.makeMessageType(
  "com.diagnocat.core.AdminOrganizationListStreamReq.DistributorClientsFilter",
  () => [
    { no: 1, name: "DistributorOwnerEmail", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
  ],
  {localName: "AdminOrganizationListStreamReq_DistributorClientsFilter"},
);

/**
 * @generated from message com.diagnocat.core.AdminOrganizationListStreamReq.DSOClientsFilter
 */
export const AdminOrganizationListStreamReq_DSOClientsFilter = proto3.makeMessageType(
  "com.diagnocat.core.AdminOrganizationListStreamReq.DSOClientsFilter",
  () => [
    { no: 1, name: "DSOOwnerEmail", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
  ],
  {localName: "AdminOrganizationListStreamReq_DSOClientsFilter"},
);

/**
 * @generated from message com.diagnocat.core.AdminOrganizationListStreamReq.DSOsFilter
 */
export const AdminOrganizationListStreamReq_DSOsFilter = proto3.makeMessageType(
  "com.diagnocat.core.AdminOrganizationListStreamReq.DSOsFilter",
  () => [
    { no: 1, name: "OwnerEmail", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
  ],
  {localName: "AdminOrganizationListStreamReq_DSOsFilter"},
);

/**
 * @generated from message com.diagnocat.core.AdminOrganizationListStreamSort
 */
export const AdminOrganizationListStreamSort = proto3.makeMessageType(
  "com.diagnocat.core.AdminOrganizationListStreamSort",
  () => [
    { no: 1, name: "By", kind: "enum", T: proto3.getEnumType(AdminOrganizationListStreamSortBy) },
    { no: 2, name: "Ascending", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ],
);

/**
 * @generated from message com.diagnocat.core.AdminOrganizationListStreamResp
 */
export const AdminOrganizationListStreamResp = proto3.makeMessageType(
  "com.diagnocat.core.AdminOrganizationListStreamResp",
  () => [
    { no: 10, name: "InitialOrganizations", kind: "message", T: AdminOrganizationListStreamResp_OrganizationsList, oneof: "Update" },
    { no: 11, name: "OrganizationUpdated", kind: "message", T: Organization, oneof: "Update" },
    { no: 101, name: "Ping", kind: "message", T: Empty, oneof: "Update" },
  ],
);

/**
 * @generated from message com.diagnocat.core.AdminOrganizationListStreamResp.OrganizationsList
 */
export const AdminOrganizationListStreamResp_OrganizationsList = proto3.makeMessageType(
  "com.diagnocat.core.AdminOrganizationListStreamResp.OrganizationsList",
  () => [
    { no: 1, name: "Organizations", kind: "message", T: Organization, repeated: true },
  ],
  {localName: "AdminOrganizationListStreamResp_OrganizationsList"},
);

/**
 * @generated from message com.diagnocat.core.AdminUserInfoStreamReq
 */
export const AdminUserInfoStreamReq = proto3.makeMessageType(
  "com.diagnocat.core.AdminUserInfoStreamReq",
  () => [
    { no: 2, name: "UserID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message com.diagnocat.core.AdminUserInfoStreamResp
 */
export const AdminUserInfoStreamResp = proto3.makeMessageType(
  "com.diagnocat.core.AdminUserInfoStreamResp",
  () => [
    { no: 11, name: "HistoricalUser", kind: "message", T: User, oneof: "Update" },
    { no: 12, name: "HistoricalOrganization", kind: "message", T: Organization, oneof: "Update" },
    { no: 13, name: "EndOfHistoricalOrganization", kind: "message", T: Empty, oneof: "Update" },
    { no: 14, name: "HistoricalOrganizationStaff", kind: "message", T: OrganizationStaff, oneof: "Update" },
    { no: 15, name: "EndOfHistoricalOrganizationStaff", kind: "message", T: Empty, oneof: "Update" },
    { no: 16, name: "HistoricalSharingInfo", kind: "message", T: AdminUserInfoStreamResp_OrganizationUserSharingInfo, oneof: "Update" },
    { no: 17, name: "EndOfHistoricalUserSharings", kind: "message", T: Empty, oneof: "Update" },
    { no: 21, name: "UpdatedUser", kind: "message", T: User, oneof: "Update" },
    { no: 22, name: "UpdatedOrganizationStaff", kind: "message", T: OrganizationStaff, oneof: "Update" },
    { no: 23, name: "UpdatedSharingInfo", kind: "message", T: AdminUserInfoStreamResp_OrganizationUserSharingInfo, oneof: "Update" },
    { no: 101, name: "Ping", kind: "message", T: Empty, oneof: "Update" },
  ],
);

/**
 * @generated from message com.diagnocat.core.AdminUserInfoStreamResp.OrganizationUserSharingInfo
 */
export const AdminUserInfoStreamResp_OrganizationUserSharingInfo = proto3.makeMessageType(
  "com.diagnocat.core.AdminUserInfoStreamResp.OrganizationUserSharingInfo",
  () => [
    { no: 1, name: "OrganizationID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "OrganizationName", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "OrganizationContacts", kind: "message", T: OrganizationContacts },
    { no: 11, name: "AcceptedSharingCount", kind: "scalar", T: 13 /* ScalarType.UINT32 */ },
    { no: 12, name: "PendingSharingCount", kind: "scalar", T: 13 /* ScalarType.UINT32 */ },
    { no: 13, name: "CanceledSharingCount", kind: "scalar", T: 13 /* ScalarType.UINT32 */ },
  ],
  {localName: "AdminUserInfoStreamResp_OrganizationUserSharingInfo"},
);

/**
 * @generated from message com.diagnocat.core.SetOrganizationFeatureFlagReq
 */
export const SetOrganizationFeatureFlagReq = proto3.makeMessageType(
  "com.diagnocat.core.SetOrganizationFeatureFlagReq",
  () => [
    { no: 1, name: "OrganizationID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "FeatureFlag", kind: "enum", T: proto3.getEnumType(FeatureFlag) },
    { no: 3, name: "Value", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ],
);

/**
 * @generated from message com.diagnocat.core.SetOrganizationFeatureFlagResp
 */
export const SetOrganizationFeatureFlagResp = proto3.makeMessageType(
  "com.diagnocat.core.SetOrganizationFeatureFlagResp",
  () => [
    { no: 1, name: "Organization", kind: "message", T: Organization },
  ],
);

/**
 * @generated from message com.diagnocat.core.MarkOrganizationAsDistributorReq
 */
export const MarkOrganizationAsDistributorReq = proto3.makeMessageType(
  "com.diagnocat.core.MarkOrganizationAsDistributorReq",
  () => [
    { no: 1, name: "OrganizationID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "DistributorName", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message com.diagnocat.core.MarkOrganizationAsDistributorResp
 */
export const MarkOrganizationAsDistributorResp = proto3.makeMessageType(
  "com.diagnocat.core.MarkOrganizationAsDistributorResp",
  () => [
    { no: 1, name: "Organization", kind: "message", T: Organization },
  ],
);

/**
 * @generated from message com.diagnocat.core.UnmarkOrganizationAsDistributorReq
 */
export const UnmarkOrganizationAsDistributorReq = proto3.makeMessageType(
  "com.diagnocat.core.UnmarkOrganizationAsDistributorReq",
  () => [
    { no: 1, name: "OrganizationID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message com.diagnocat.core.UnmarkOrganizationAsDistributorResp
 */
export const UnmarkOrganizationAsDistributorResp = proto3.makeMessageType(
  "com.diagnocat.core.UnmarkOrganizationAsDistributorResp",
  () => [
    { no: 1, name: "Organization", kind: "message", T: Organization },
  ],
);

/**
 * @generated from message com.diagnocat.core.SetOrganizationDistributorReq
 */
export const SetOrganizationDistributorReq = proto3.makeMessageType(
  "com.diagnocat.core.SetOrganizationDistributorReq",
  () => [
    { no: 1, name: "OrganizationID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "DistributorID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "DistributorEmail", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message com.diagnocat.core.SetOrganizationDistributorResp
 */
export const SetOrganizationDistributorResp = proto3.makeMessageType(
  "com.diagnocat.core.SetOrganizationDistributorResp",
  () => [
    { no: 1, name: "Organization", kind: "message", T: Organization },
  ],
);

/**
 * @generated from message com.diagnocat.core.MarkOrganizationAsDSOReq
 */
export const MarkOrganizationAsDSOReq = proto3.makeMessageType(
  "com.diagnocat.core.MarkOrganizationAsDSOReq",
  () => [
    { no: 1, name: "OrganizationID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message com.diagnocat.core.MarkOrganizationAsDSOResp
 */
export const MarkOrganizationAsDSOResp = proto3.makeMessageType(
  "com.diagnocat.core.MarkOrganizationAsDSOResp",
  () => [
    { no: 1, name: "Organization", kind: "message", T: Organization },
  ],
);

/**
 * @generated from message com.diagnocat.core.UnmarkOrganizationAsDSOReq
 */
export const UnmarkOrganizationAsDSOReq = proto3.makeMessageType(
  "com.diagnocat.core.UnmarkOrganizationAsDSOReq",
  () => [
    { no: 1, name: "OrganizationID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message com.diagnocat.core.UnmarkOrganizationAsDSOResp
 */
export const UnmarkOrganizationAsDSOResp = proto3.makeMessageType(
  "com.diagnocat.core.UnmarkOrganizationAsDSOResp",
  () => [
    { no: 1, name: "Organization", kind: "message", T: Organization },
  ],
);

/**
 * @generated from message com.diagnocat.core.SetOrganizationDSOParentReq
 */
export const SetOrganizationDSOParentReq = proto3.makeMessageType(
  "com.diagnocat.core.SetOrganizationDSOParentReq",
  () => [
    { no: 1, name: "OrganizationID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "DSOParentOrganizationID", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
  ],
);

/**
 * @generated from message com.diagnocat.core.SetOrganizationDSOParentResp
 */
export const SetOrganizationDSOParentResp = proto3.makeMessageType(
  "com.diagnocat.core.SetOrganizationDSOParentResp",
  () => [
    { no: 1, name: "Organization", kind: "message", T: Organization },
  ],
);

/**
 * `LoadThresholds` - boundaries mapping a raw metric to a load level:
 * value >= High -> high; value >= Medium -> medium; else low
 *
 * @generated from message com.diagnocat.core.LoadThresholds
 */
export const LoadThresholds = proto3.makeMessageType(
  "com.diagnocat.core.LoadThresholds",
  () => [
    { no: 1, name: "Medium", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 2, name: "High", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
  ],
);

/**
 * `SystemLoadSourceView` - full load state of one source
 *
 * @generated from message com.diagnocat.core.SystemLoadSourceView
 */
export const SystemLoadSourceView = proto3.makeMessageType(
  "com.diagnocat.core.SystemLoadSourceView",
  () => [
    { no: 1, name: "RawValue", kind: "scalar", T: 3 /* ScalarType.INT64 */, opt: true },
    { no: 2, name: "ComputedLevel", kind: "enum", T: proto3.getEnumType(LoadLevel) },
    { no: 3, name: "Manual", kind: "enum", T: proto3.getEnumType(LoadLevel) },
    { no: 4, name: "EffectiveLevel", kind: "enum", T: proto3.getEnumType(LoadLevel) },
    { no: 5, name: "Thresholds", kind: "message", T: LoadThresholds },
    { no: 6, name: "Enabled", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ],
);

/**
 * @generated from message com.diagnocat.core.SystemLoadView
 */
export const SystemLoadView = proto3.makeMessageType(
  "com.diagnocat.core.SystemLoadView",
  () => [
    { no: 1, name: "UploadKafka", kind: "message", T: SystemLoadSourceView },
    { no: 2, name: "UploadCBCT", kind: "message", T: SystemLoadSourceView },
    { no: 3, name: "PipelineOrgPending", kind: "message", T: SystemLoadSourceView },
    { no: 4, name: "PipelineOrgsCount", kind: "message", T: SystemLoadSourceView },
    { no: 5, name: "ComputedAt", kind: "message", T: Timestamp },
  ],
);

/**
 * @generated from message com.diagnocat.core.SystemLoad_GetReq
 */
export const SystemLoad_GetReq = proto3.makeMessageType(
  "com.diagnocat.core.SystemLoad_GetReq",
  [],
);

/**
 * @generated from message com.diagnocat.core.SystemLoad_GetResp
 */
export const SystemLoad_GetResp = proto3.makeMessageType(
  "com.diagnocat.core.SystemLoad_GetResp",
  () => [
    { no: 1, name: "SystemLoad", kind: "message", T: SystemLoadView },
  ],
);

/**
 * @generated from message com.diagnocat.core.SystemLoad_SetSettingsReq
 */
export const SystemLoad_SetSettingsReq = proto3.makeMessageType(
  "com.diagnocat.core.SystemLoad_SetSettingsReq",
  () => [
    { no: 1, name: "ManualUploadKafka", kind: "enum", T: proto3.getEnumType(LoadLevel) },
    { no: 2, name: "ManualUploadCBCT", kind: "enum", T: proto3.getEnumType(LoadLevel) },
    { no: 3, name: "ManualPipelineOrgPending", kind: "enum", T: proto3.getEnumType(LoadLevel) },
    { no: 4, name: "ManualPipelineOrgsCount", kind: "enum", T: proto3.getEnumType(LoadLevel) },
    { no: 5, name: "UploadKafkaThresholds", kind: "message", T: LoadThresholds },
    { no: 6, name: "UploadCBCTThresholds", kind: "message", T: LoadThresholds },
    { no: 7, name: "PipelineOrgPendingThresholds", kind: "message", T: LoadThresholds },
    { no: 8, name: "PipelineOrgsCountThresholds", kind: "message", T: LoadThresholds },
    { no: 9, name: "UploadKafkaEnabled", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 10, name: "UploadCBCTEnabled", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 11, name: "PipelineOrgPendingEnabled", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 12, name: "PipelineOrgsCountEnabled", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ],
);

/**
 * @generated from message com.diagnocat.core.SystemLoad_SetSettingsResp
 */
export const SystemLoad_SetSettingsResp = proto3.makeMessageType(
  "com.diagnocat.core.SystemLoad_SetSettingsResp",
  () => [
    { no: 1, name: "SystemLoad", kind: "message", T: SystemLoadView },
  ],
);

